import { TFunction } from "i18next";

import { MeasurementTypes } from "../@types/Measurements";
import { SourceLegend } from "../@types/Source";
import { sourceLegends } from "../constants/sourceConstants";

// Source codes from the API arrive in whatever casing the legacy DB used
// ("dexcom", "FibriCheck", "pMp-app-manual"). sourceLegends is keyed in
// lowercase, so normalise the lookup. Falls back to the raw code if no
// legend entry exists.
/**
 * The label for a source code, translated where the source has one.
 *
 * EN-5191 follow-up: device and vendor names stay as they are (a brand is a brand in every
 * language), but the handful of sources whose name is an ordinary word — "App manual",
 * "Portal", "Dialysis" — carry a `labelKey` and resolve through it. The map key remains the
 * identity; only the label moves.
 *
 * `t` is passed in rather than reached for here so this stays callable from outside a
 * component, and so the result re-renders when the language changes. It is required so a call
 * site cannot silently keep the English label.
 */
export function getFriendlySourceName(
  code: string,
  t: TFunction | ((key: string) => string)
): string {
  const key = code.toLowerCase();
  const legend = sourceLegends[key];

  if (!legend) return code;

  if (legend.labelKey) return t(legend.labelKey);

  return legend.name || code;
}

export function getSourceLegends(
  measurementType: MeasurementTypes,
  source: string
): SourceLegend {
  const sourceLegend =
    sourceLegends[source.includes("archived") ? "archived" : source];
  let { color } = sourceLegend || {};

  if (source === "a&d_ua-651ble" || source === "bodytrace-bp") {
    if (measurementType === "bp_systolic") {
      color = sourceLegend.systolicColor;
    } else if (measurementType === "bp_diastolic") {
      color = sourceLegend.diastolicColor;
    }
  }

  return {
    ...sourceLegend,
    color,
  };
}
